export const ISOLATED_SSO_AUTHENTICATION_ATTEMPT = 'ISOLATED_SSO_AUTHENTICATION_ATTEMPT';
export const ISOLATED_SSO_AUTHENTICATION_FAILURE = 'ISOLATED_SSO_AUTHENTICATION_FAILURE';
export const ISOLATED_SSO_AUTHENTICATION_SUCCESS = 'ISOLATED_SSO_AUTHENTICATION_SUCCESS';

export const SET_SOURCE = 'SET_SOURCE';
